import React, { useState, useEffect, useRef } from "react";
// import Header from "../../components/dashboard/header";
// import Header from "../Header";
// import Footer from "../../components/dashboard/footer";
import Footer from "../Footer";
// import Footer from "../../components/dashboard/footer";
import SessionPopup from "../SessionPopup"
 import Sidebar from "../../components/dashboard/sidebar";
import DashboardHeader from "../../components/dashboard/header";

import DashboardFooter from "../../components/dashboard/footer";
import Header from "../../pages/Header";
import axios from 'axios';
import { useNavigate, useParams } from "react-router-dom";

let { lambda, appname } = window.app;

const getYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};

const Videoplayer = () => {
    // debugger
    const [playVideo, setPlayVideo] = useState(false);
    const [data, setData] = useState(null);
    const [invalidContent, setInvalidContent] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();

    const [showSessionPopupup, setShowSessionPopupup] = useState(false);

    const getData = () => {
        const token = localStorage.getItem("token")
        axios
            .get(`${lambda}/lectureLibraryInfo?appname=${appname}&lecturelibraryid=${id}`)
            .then((response) => {
                const result = response?.data?.result?.data;
                if (result === "Invalid token or Expired") {
                    setShowSessionPopupup(true);
                } else if (Array.isArray(result) && result.length > 0) {
                    setData(result[0]);
                } else {
                    setInvalidContent(true);
                }
            });
    };

    useEffect(() => {
        if (id) getData();
    }, [id]);
    const token = localStorage.getItem("token");
    return (


        <>
            {showSessionPopupup && <SessionPopup />}
            {/* <Header /> */}
            <div id="layout-wrapper" className=" video-player-landing">
                {token ? <DashboardHeader /> : <Header />}
                {token && <Sidebar />}
                <div className={`${token ? "main-content mt-4" : " "} user-management lecture-library video-player mt-4`} id="main-content">
                </div>
            </div>
            <div id="layout-wrapper"className="video-player-db" >
                {token ?
                    <div className="db-vp">
                        <section className="container col-lg-12 d-flex flex-column justify-content-center align-items-center p-0 video-section-container">
                            <div className="mb-1 p-0 col-lg-11 col-md-12 d-flex justify-content-between align-items-center all-vid-btn">
                                <div className="video-info">
                                    <h2 className="h4 fw-bold mb-1">{data?.title}</h2>
                                </div>
                                <button className="create-quiz-btn border-0 " onClick={() => navigate(-1)}>
                                    <span className="material-symbols-outlined ">arrow_back</span><span>All Videos</span>
                                </button>
                            </div>
                            <div className="col-lg-11 col-md-12 align-items-start video-description">
                                {/* Main Video */}
                                <div className="video-img-vid col-lg-12 ratio ratio-16x9 mb-2 rounded overflow-hidden" style={{ cursor: 'pointer' }} onClick={() => {
                                    setPlayVideo(true);
                                }}>
                                    <iframe
                                        className="rounded"
                                        src={`https://www.youtube.com/embed/${getYouTubeVideoId(data?.youtube)}?autoplay=1&rel=0&modestbranding=1`}
                                        title="Video player"
                                        allowFullScreen
                                        allow="autoplay; encrypted-media"
                                    ></iframe>
                                </div>

                                {/* Video Info */}
                                <div className="col-lg-12 col-md-12 video-info">
                                    {/* <h2 className="h4 fw-bold mb-1">{data?.title}</h2> */}
                                    <p className="text-dark video-decription">
                                        <b>Video Description:</b> <br></br>
                                        {data?.description}</p>
                                </div>
                            </div>
                        </section>
                    </div> : <section className="container col-lg-12 d-flex flex-column justify-content-center align-items-center p-0 video-section-container">
                        <div className="mb-1 p-0 col-lg-11 col-md-12 d-flex justify-content-between align-items-center all-vid-btn">
                            <div className="video-info">
                                <h2 className="h4 fw-bold mb-1">{data?.title}</h2>
                            </div>
                            <button className="create-quiz-btn border-0 " onClick={() => navigate(-1)}>
                                <span className="material-symbols-outlined ">arrow_back</span><span>All Videos</span>
                            </button>
                        </div>
                        <div className="col-lg-11 col-md-12 align-items-start video-description">
                            {/* Main Video */}
                            <div className="video-img-vid col-lg-12 ratio ratio-16x9 mb-2 rounded overflow-hidden" style={{ cursor: 'pointer' }} onClick={() => {
                                setPlayVideo(true);
                            }}>
                                <iframe
                                    className="rounded"
                                    src={`https://www.youtube.com/embed/${getYouTubeVideoId(data?.youtube)}?autoplay=1&rel=0&modestbranding=1`}
                                    title="Video player"
                                    allowFullScreen
                                    allow="autoplay; encrypted-media"
                                ></iframe>
                            </div>

                            {/* Video Info */}
                            <div className="col-lg-12 col-md-12 video-info">
                                {/* <h2 className="h4 fw-bold mb-1">{data?.title}</h2> */}
                                <p className="text-dark video-decription">
                                    <b>Video Description:</b> <br></br>
                                    {data?.description}</p>
                            </div>

                        </div>
                    </section>}
                {token && <DashboardFooter />}
            </div>




            {!token && <Footer />}

        </>



    );
};

export default Videoplayer;
